import React, { useState } from "react";
import "../../../CSS/simple-sidebar.css";
import history from "../../../historial";
import {
  Media,
  Container,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText,
} from "reactstrap";
import SideBar from "../../../Img/SideBar.png";
import IcoInicio from "../../../Img/IconSideBar/Inicio.png";
import IcoSubir from "../../../Img/IconSideBar/Subir.png";
import IcoConsultar from "../../../Img/IconSideBar/Consultar.png";
import IcoValidar from "../../../Img/IconSideBar/Validar.png";
import IcoPagos from "../../../Img/IconSideBar/Pagos.png";
import IcoRegresar from "../../../Img/IconSideBar/Regresar.png";

const Navigation = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);
  return (
    <div style={{ backgroundColor: "black", height: "100%" }}>
      <div
        className="text-center"
        style={{
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "2em",
        }}
      >
        {`Bienvenido(a):`}
      </div>
      <div
        className="text-center pb-3"
        style={{
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "2em",
        }}
      >
        {`${props.nombre_completo}`}
      </div>

      <Navbar
        dark
        expand="lg"
        style={{
          background: `url(${SideBar})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <NavbarToggler onClick={toggle} style={{ color: "white" }} />
        <Collapse isOpen={isOpen} navbar>
          <Nav vertical className="mr-auto" navbar style={{ width: "100%" }}>
            <NavItem>
              <a href="/aspiranteInicio" class="list-group-item text-white">
                <Media
                  object
                  src={IcoInicio}
                  style={{
                    maxHeigth: "2em",
                    maxWidth: "2em",
                    marginRight: "1em",
                  }}
                />
                Inicio
              </a>
            </NavItem>
            <NavItem>
              <a
                href="/aspiranteSubirDocumentos"
                class="list-group-item text-white"
              >
                <Media
                  object
                  src={IcoSubir}
                  style={{
                    maxHeigth: "2em",
                    maxWidth: "2em",
                    marginRight: "1em",
                  }}
                />
                Subir Documentos
              </a>
            </NavItem>
            {/* <NavItem>
                            <a href="/aspiranteEstadoDocumentos" class="list-group-item text-white">
                                <Media object src={IcoConsultar} style={{ maxHeigth: '2em', maxWidth: '2em', marginRight: '1em' }} />
                        Consultar Estado
                        </a>
                        </NavItem> */}
           {/* { new Date() >= new Date("2023-01-16 10:00:00") && (<NavItem>
              <a href="/aspirantePago" class="list-group-item text-white">
                <Media
                  object
                  src={IcoPagos}
                  style={{
                    maxHeigth: "2em",
                    maxWidth: "2em",
                    marginRight: "1em",
                  }}
                />
                Pago
              </a>
                </NavItem>)} */}

                {/* para comunicar numeros de control, nip y pass de email, poner fecha de publicacion*/}
            {new Date() >= new Date("2023-08-16 08:00:00") && (
              <NavItem>
                <a
                  href="/aspiranteNuevoIngreso"
                  class="list-group-item text-white"
                >
                  <Media
                    object
                    src={IcoValidar}
                    style={{
                      maxHeigth: "2em",
                      maxWidth: "2em",
                      marginRight: "1em",
                    }}
                  />
                  MindBox - Número de control
                </a>
              </NavItem>
                  )}

            <NavItem>
              <a href="" onClick={salir} class="list-group-item text-white">
                <Media
                  object
                  src={IcoRegresar}
                  style={{
                    maxHeigth: "2em",
                    maxWidth: "2em",
                    marginRight: "1em",
                  }}
                />
                Salir
              </a>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};

const salir = () => {
  localStorage.clear();
  sessionStorage.clear();
  history.push("/");
};

export default Navigation;

